<div *ngIf="label" class="label" [class]="cssClass ? cssClass.toLowerCase() : ''" [ngClass]="translateContent ? '' : 'notranslate'">
    <svg width="100%" height="100%" viewBox="0 0 23 18">
        <text x="0" y="9" style="alignment-baseline: middle;">
            {{label.toUpperCase()}}
        </text>
    </svg>
</div>